export const datasetFilterConfig = {
    NHANES: {
      filters: ['All', 'US Male', 'US Female'],
      defaultFilter: 'All',
    },
} as const;

export type DatasetKey = keyof typeof datasetFilterConfig;
